<template>
  <v-container style="height: 100%; overflow-y: auto;">
    <div>
      <h1>Impressum</h1>
      <section>
        <p>Dies ist ein Projekt der Creative Crowd vertreten durch youplant UG (haftungsbeschränkt), prosa clothing UG (haftungsbeschränkt) & Co. KG , LEMIWA - Leben mit wasser, veenoir - seifert software solutions</p>
        <p>e-Mail: info@handelt-gemeinsam.de</p>
        <p>Thomas-Mann-Straße 27, 07743 Jena</p>
        <p>Plattform der EU-Kommission zur Online-Streitbeilegung: https://ec.europa.eu/odr</p>
        <p>Wir sind zur Teilnahme an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle weder verpflichtet noch bereit.</p>
      </section>
    </div>
  </v-container>
</template>

<script>
export default {
  name: 'ViewImpressum',
  data: function() {
    return {
    };
  },
};
</script>

<style scoped type='text/css'>

</style>